import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import { encodeSearchTerms, spUrl } from "utils";
import {
	buildSearchParams,
	patch,
	put,
	remove,
	request,
	save,
} from "utils/proxy";
import {
	API_NOTES,
	API_PROPOSAL,
	API_PROPOSAL_FEED,
	API_PROPOSALS_SUMMARY,
} from "globals/constants";


export const proposal = {
	create: (body, options) => save(spUrl(`${API_PROPOSAL}?strict=true`), body, options),

	get: (id, options) => request(spUrl(`${API_PROPOSAL}/${id}`), options),

	getList: (searchParams, options) => {
		const params = {
			page: parseInt(searchParams.page),
			size: parseInt(searchParams.size),
			search: searchParams.search ? encodeSearchTerms(searchParams.search) : "",
			fields: isNonEmptyArray(searchParams.fields) ? searchParams.fields.join(",") : "",
		};

		return request(spUrl(`${API_PROPOSAL_FEED}${buildSearchParams(params)}`), options);
	},

	getValues: (id, searchParams, options) =>
		request(spUrl(`${API_PROPOSAL_FEED}/${id}${buildSearchParams(searchParams)}`), options),

	getSummary: (searchParams = { groupBy: "status" }, options) =>
		request(spUrl(`${API_PROPOSALS_SUMMARY}${buildSearchParams(searchParams)}`), options),

	getReviews: (id, options) => request(spUrl(`${API_PROPOSAL}/${id}/reviews`), options),

	getCertifications: (id, options) => request(spUrl(`${API_PROPOSAL}/${id}/certifications`), options),

	updateCertifications: (params, body, options) =>
		put(spUrl(`${API_PROPOSAL_FEED}/${params.id}/certification`), body, options),

	/**
	 * @param {{formId}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	updateAdminTeamMember: (params, body, options) =>
		put(spUrl(`${API_PROPOSAL}/${params.formId}/admin-team-members`), body, options),

	/**
	 * @param {{formId}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	updateAccess: (params, body, options) => put(spUrl(`${API_PROPOSAL}/${params.formId}/accesses`), body, options),

	/**
	 * @param {{id}} params
	 * @param {{}?} options
	 * @returns {Promise<any>}
	 */
	getStatus: (params, options) => request(spUrl(`${API_PROPOSAL}/${params.id}/status/flow`), options),

	/**
	 * @param {{id}} params
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	updateStatus: (params, body, options) => put(spUrl(`${API_PROPOSAL}/${params.id}/status`), body, options),

	/**
	 * @param {{id}} params
	 * @param {{}?} body
	 * @param {{}?} options
	 * @returns {Promise<{}>}
	 */
	saveStatus: (params, body, options) => save(spUrl(`${API_PROPOSAL}/${params.id}/status`), body, options),

	routeForReview: (params, body, options) => save(spUrl(`${API_PROPOSAL}/${params.id}/route`), body, options),

	/**
	 * @param {{proposalId}} params
	 * @param {*} searchParams
	 * @param {{}?} options
	 */
	getNotes: (params, searchParams, options) =>
			request(spUrl(`${API_NOTES}/proposals/${params.proposalId}${buildSearchParams(searchParams)}`), options),

	/**
	 * @param {{proposalId}} params
	 * @param {{}?} body
	 * @param {{}?} options
	 */
	saveNote: (params, body, options) =>
			save(spUrl(`${API_NOTES}/proposals/${params.proposalId}`), body, options),

	/**
	 * @param {{proposalId, noteId}} params
	 * @param {{}} body
	 * @param {{}?} options
	 */
	updateNote: (params, body, options) =>
			put(spUrl(`${API_NOTES}/${params.noteId}/proposals/${params.proposalId}`), body, options),

	/**
	 * @param {{proposalId: string, noteId: string}} params
	 * @param {{}?} options
	 */
	deleteNote: (params, options) => remove(spUrl(`${API_NOTES}/${params.noteId}/proposals/${params.proposalId}`), options),

	/**
	 * @param {{proposalId, attachmentId}} params
	 * @param {{}?} options
	 */
	deleteAttachment: (params, options) =>
		remove(spUrl(`${API_NOTES}/proposals/${params.proposalId}/attachments/${params.attachmentId}`), options),

	/**
	 * @param {{}} body
	 * @param {{}?} options
	 * @returns {Promise<any>}
	 */
	updateAdminMembers: (body, options) => patch(spUrl(`${API_PROPOSAL}/adminMembers`), body, options),
};
